import {
  CLEAR_FETCHED_STAFF,
  SEARCH_STAFF,
  SEARCH_STAFF_FAILURE,
  SEARCH_STAFF_SUCCESS,
} from '../constants/ActionTypes';

const DEFAULT_STATE = {
  fetchedStaff: [],
  loading: false,
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CLEAR_FETCHED_STAFF:
      return {
        ...state,
        fetchedStaff: [],
      };
    case SEARCH_STAFF:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_STAFF_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_STAFF_SUCCESS:
      return {
        ...state,
        fetchedStaff: action.payload.fetchedStaff,
        loading: false,
      };
    default:
      return state;
  }
};
